/*
 * Mother of Macros: begin_checkout on checkout button clicks.
 *
 * Stape's own begin_checkout event comes from Shopify's checkout pages and is not arriving.
 * This sends the same event from the storefront when a shopper clicks a checkout button, so
 * the existing GTM-MBZDVXPX trigger "ce - begin_checkout_stape" fires its tags (GA4
 * begin_checkout, Meta InitiateCheckout, ...) without any GTM change.
 *
 * - Event name and data format follow the Stape app (event, ecommerce, cart_state, ...).
 * - Only real attempts count: clicks stopped by the order minimum (mom-minimum.js stops them
 *   earlier in the same capture phase) or on disabled buttons send nothing, and the same cart
 *   is sent once per 10 minutes, so double clicks and back-and-forth do not double count.
 * - Turned off in Theme settings > Tracking > "Send begin_checkout on checkout click"
 *   (window.MOM_BEGIN_CHECKOUT_CLICK = false), e.g. if Stape's checkout event is fixed later.
 *
 * Express buttons (Shop Pay, PayPal) live in their own frames and are not covered.
 */
(function () {
  'use strict';

  if (window.MOMBeginCheckoutLoaded || window.MOM_BEGIN_CHECKOUT_CLICK === false) return;
  window.MOMBeginCheckoutLoaded = true;

  var EVENT_NAME = 'begin_checkout';
  var DEDUPE_KEY = 'mom_begin_checkout_sent';
  var DEDUPE_MS = 10 * 60 * 1000;
  var CHECKOUT_SELECTOR = [
    '#CartDrawer-Checkout',
    '#checkout',
    '.cart__checkout-button',
    'button[name="checkout"]',
    'input[name="checkout"]',
    '[data-alc-action="checkout"]',
    'a[href="/checkout"]',
    'a[href^="/checkout?"]'
  ].join(',');

  var cachedCart = null;

  function money(cents) {
    return (Math.round(cents || 0) / 100).toFixed(2);
  }

  function latestCart() {
    return (window.MOMMinimum && window.MOMMinimum.getCart && window.MOMMinimum.getCart()) || cachedCart;
  }

  function refreshCache() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) { cachedCart = cart; return cart; })
      .catch(function () { return null; });
  }

  function pageType() {
    var path = window.location.pathname;
    if (path === '/') return 'home';
    if (path.indexOf('/cart') === 0) return 'cart';
    if (path.indexOf('/products/') === 0) return 'product';
    if (path.indexOf('/collections/') === 0) return 'category';
    return 'other';
  }

  function alreadySent(signature) {
    try {
      var saved = JSON.parse(window.sessionStorage.getItem(DEDUPE_KEY) || 'null');
      return Boolean(saved && saved.signature === signature && Date.now() - saved.at < DEDUPE_MS);
    } catch (error) {
      return false;
    }
  }

  function remember(signature) {
    try {
      window.sessionStorage.setItem(DEDUPE_KEY, JSON.stringify({ signature: signature, at: Date.now() }));
    } catch (error) { /* storage unavailable: no dedupe, still send */ }
  }

  function send() {
    var cart = latestCart();
    if (!cart || !cart.items || !cart.items.length) return;

    var signature = [cart.token, cart.item_count, cart.total_price].join('|');
    if (alreadySent(signature)) return;
    remember(signature);

    var currency = cart.currency || 'USD';
    var items = cart.items.map(function (item, index) {
      return {
        item_id: String(item.product_id),
        item_sku: item.sku || '',
        item_variant: String(item.variant_id),
        item_name: item.product_title,
        variant_name: item.variant_title || 'Default Title',
        item_brand: item.vendor || 'Mother of Macros',
        price: Number(money(item.final_price)),
        quantity: item.quantity,
        item_url: item.url,
        index: index + 1
      };
    });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: EVENT_NAME,
      ecommerce: {
        currency: currency,
        value: money(cart.total_price),
        cart_total: money(cart.total_price),
        cart_quantity: cart.items.length,
        items: items
      },
      cart_state: {
        cart_id: cart.token || null,
        cart_quantity: cart.item_count,
        cart_value: money(cart.total_price),
        currency: currency,
        lines: cart.items.map(function (item) {
          return {
            item_variant: String(item.variant_id),
            item_id: String(item.product_id),
            item_sku: item.sku || '',
            item_name: item.product_title,
            quantity: item.quantity,
            line_total_price: money(item.final_line_price),
            price: money(item.final_price)
          };
        })
      },
      actual_url: window.location.href,
      ecomm_pagetype: pageType(),
      event_source: 'theme_checkout_click'
    });
  }

  // Registered on document in the capture phase after mom-minimum.js (loaded first), so a click
  // that the order-minimum guard stops never reaches this listener.
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var control = target.closest(CHECKOUT_SELECTOR);
    if (!control) return;
    if (control.disabled || control.getAttribute('aria-disabled') === 'true') return;
    send();
  }, true);

  // Keep a copy of the cart for pages where mom-minimum.js has not loaded it yet.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshCache);
  else refreshCache();
})();
